export const BASENAME = '/'
